module.exports = __webpack_public_path__ + "img/image-17.d16265a9.jpg";